import { create } from '@theme/create';

export const themed = create(
  new (function () {
    this.wrapper = {
      gridArea: 'email',
      width: ['100%', '300px'],
      py: [12, 0],
      px: [8, 0],
      '@media only screen and (min-width: 1024px) and (max-width: 1060px)': {
        width: '210px',
      },
      '@media only screen and (min-width: 1061px) and (max-width: 1140px)': {
        width: '250px',
      },
    };

    this.header = {
      mb: [8, 11],
    };

    this.heading = {
      fontSize: ['18px', 3],
      lineHeight: ['22px', '20px'],
      fontWeight: [400, 500],
      fontFamily: 'body',
    };

    this.subtext = {
      fontFamily: 'body',
      fontSize: ['14px', 3],
      lineHeight: ['20px', '19px'],
      mt: 8,
    };

    this.input = {
      width: '100%',
    };
  })()
);
